/**
 * Иконка браузера (карточка Web sites).
 */

function IconWebsites() {
    return (
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
                <filter id="webGlow" x="-40%" y="-40%" width="180%" height="180%">
                    <feGaussianBlur stdDeviation="1.2" result="blur"/>
                    <feMerge>
                        <feMergeNode in="blur"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g filter="url(#webGlow)">
                {/* Browser frame */}
                <rect x="4" y="4" width="92" height="88" rx="8" stroke="#B8FF65" strokeWidth="3.5"/>
                {/* Header divider */}
                <line x1="4" y1="25" x2="96" y2="25" stroke="#B8FF65" strokeWidth="3.5"/>
                {/* Three dots */}
                <circle cx="17" cy="14.5" r="4" fill="#B8FF65"/>
                <circle cx="30" cy="14.5" r="4" fill="#B8FF65"/>
                <circle cx="43" cy="14.5" r="4" fill="#B8FF65"/>
                {/* Cursor arrow */}
                <g transform="translate(19, 48) scale(0.56)">
                    <path d="M41 41.6543L2 4.6543V59.1543L14.5 47.1543L24 66.6543L33 62.6543L24.5 42.6543L41 41.6543Z" fill="#B8FF65"/>
                </g>
            </g>
        </svg>
    );
}

export default IconWebsites;
// assets/icons/IconWebsites.js
